import { Fragment, useState, useRef } from 'react'
import { Transition } from '@headlessui/react'
import {
  useHistory
} from "react-router-dom";

import UserService from '../../services/UserService'
import Cta from '../../components/Cta'

import { useNotification } from '../../providers/NotificationProvider';
import { useCookies } from 'react-cookie';
import { isExpired, decodeToken } from "react-jwt";
import ReactGA from "react-ga4"

//FixMe: This is duplicated and should be centralized
var styles = {
  "style-1": "inline-flex items-center justify-center px-14 py-5 border border-black font-cta-label text-base font-medium rounded-full text-black bg-white hover:bg-blue-500",
  "style-2": "inline-flex items-center justify-center px-14 py-5 border border-transparent font-cta-label text-base font-medium rounded-full text-white bg-blue-500 hover:bg-blue-700",
}

const formClass = "appearance-none block w-full px-8 py-4 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 font-primary text-login-form-input-mobile lg:text-login-form-input";

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

function FormInput(props) {
  var divStyle = "";

  return (
    <div className={divStyle}>
      <div className="">
        <input
          id={props.id}
          name={props.id}
          type={props.type}
          autoComplete={props.autocomplete || props.id}
          placeholder={props.placeholder || props.id}
          required={props.required}
					onClick={props.onClick || "" }
          className=""
        />
      </div>
    </div>
  )
}


function GiveawayForm(props) {
    const [ notification, notificationDispatch ] = useNotification();
    const [ cookies, setCookies ] = useCookies([]);
    const [ loading, isLoading ] = useState(false);
    const [ hasToken, setHasToken ] = useState(!(props.token === null));

    const token = decodeToken(props.token) || {};
    const userDefault = {
      email: token.email || "",
      firstName: token["custom:first_name"] || "",
      lastName: token["custom:last_name"] || "",
      password: "",
      business: "",
      zip: "",
      affiliateId: cookies['affiliate-link'],
      token: props.token,
    }

    const history = useHistory();

		const [ showForm, setShowForm ] = useState(!(props.token == null));
    const [ form, setFormData ] = useState(userDefault);

    const notificationTimeout = useRef(null);
    const loadingBarRef = props.loadingBarRef;

    const setLoading = (loading) => {
      if (loading) {
        isLoading(true);
        loadingBarRef.current.continuousStart();
      } else {
        isLoading(false);
        loadingBarRef.current.complete();
      }
    }

    const submitRegistration = (evt) => {
      evt.preventDefault();

      clearTimeout(notificationTimeout.current);
      setLoading(true);
      let user = {
        email: form.email,
        firstName: form.firstName,
        lastName: form.lastName,
        business: form.business || 'N/A',
        zipcode: form.zip,
      };

      UserService.registerUser(user, form.password, hasToken).then((response) => {
        if (response.data.errors) {
          notificationDispatch({ type: 'show_error', payload: { message: "Registration Error." } });
          setLoading(false);
        } else {
          let register = response.data.data.registerUser;
          if (register.success === true) {
            notificationDispatch({ type: 'show_notification', payload: { message: "User registered. Please check email for verification link." } });
            ReactGA.gtag("event", "sign_up"); // This shoudl be in the Provider...

            setFormData(userDefault);
            setShowForm(false);
            setLoading(false);
            if (hasToken) {
              history.replace("/");
            } else {
              props.setConfirmed(true);
            }
          } else {
            notificationDispatch({ type: 'show_error', payload: { message: register.message } });
            window.scrollTo(0, 0)
            notificationTimeout.current = setTimeout(() => {
              notificationDispatch({ type: "notification/hide" });
            }, 5000);
            setLoading(false);
          }
        }
      });
    }

    return (
            <div className="mt-5 md:mt-10 mx-auto md:w-120" >
              <form onSubmit={submitRegistration} method="POST" className="space-y-4">

                <input 
                  id="email"
                  type="input"
                  placeholder='Email'
                  className={formClass}
                  disabled={hasToken || loading}
                  value={form.email}
                  onClick={() => setShowForm(true)}
                  onChange={(evt) => setFormData({...form, email: evt.target.value})}
                  required
                />

      					<Transition
                  show={showForm}
                  className="space-y-4"
                  enter="transform ease-out duration-300 transition"
                  enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                  enterTo="translate-y-0 opacity-100 sm:translate-x-0"
                  leave="transition ease-in duration-100"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
								>

                	<input
                    id="firstname"
                    type="input"
                    placeholder='First Name'
                    autocomplete="firstname"
                    disabled={loading}
                    className={formClass}
                    spacing='1'
                    value={form.firstName}
                    onChange={(evt) => setFormData({...form, firstName: evt.target.value})}
                    required
                  />

                	<input
                    id="lastname"
                    type="input"
                    placeholder='Last Name'
                    autocomplete="lastname"
                    disabled={loading}
                    className={formClass}
                    spacing='1'
                    value={form.lastName}
                    onChange={(evt) => setFormData({...form, lastName: evt.target.value})}
                    required
                  />

                	<input
                    id="business"
                    type="input"
                    placeholder='Business Name (If applicable)'
                    autocomplete="business-name"
                    disabled={loading}
                    className={formClass}
                    spacing='1'
                    value={form.business}
                    onChange={(evt) => setFormData({...form, business: evt.target.value})}
                  />

                	<input
                    id="zip"
                    type="input"
                    placeholder='Zip Code'
                    autocomplete="zip"
                    disabled={loading}
                    className={formClass}
                    spacing='1'
                    value={form.zip}
                    onChange={(evt) => setFormData({...form, zip: evt.target.value})}
                    required
                  />

                  {!hasToken &&
                	<input
                    id="password"
                    type="password"
                    placeholder='Password'
                    className={formClass}
                    disabled={loading}
                    spacing='1'
                    value={form.password}
                    onChange={(evt) => setFormData({...form, password: evt.target.value})}
                    required
                  />
                  }

                  <div>
                    <button
                      type="submit"
                      disabled={loading}
                      className="inline-flex items-center justify-center px-14 py-4 border border-transparent font-cta-label text-cta-label-mobile md:text-cta-label font-medium rounded-full text-white bg-blue-500 hover:bg-blue-400 disabled:bg-grey-light"
                      >Let's get started!</button>
                  </div>
								</Transition>

              </form>
    </div>
  )
}

export default GiveawayForm;


